module.exports = __webpack_public_path__ + "img/information.a9eb4637.svg";